import api from '../../../../config/api.service';
import Cookies from 'universal-cookie';

class FormularioPeticao {

    protected cookies = new Cookies();

    async listFormularios(params: any) {
        const resp = await api.get(`listFormularios`, { params: params })
            .then((resp) => resp.data)
            .catch((err) => {
                return err.response.data.message
            });

        return resp;
    };

    async createFormularioPeticao(data: any) {

        const resp = await api.post("createFormularioPeticao", data)
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async getFormularioPeticaoById(idFormularioPeticao: any) {
        const resp = await api.get("getFormularioPeticaoById", { params: { idFormularioPeticao } })
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async getGrupoTrabalho() {
        const resp = await api.get('getGrupoTrabalho')
            .then((resp) => resp.data)
            .catch((err) => {
                return err.response.data.message
            });

        return resp;
    };

    async getNumeroRegistroFormularioPeticao(registroDenuncia: any) {
        const resp = await api.get("getNumeroRegistroFormularioPeticao", { params: { registroDenuncia } })
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp
    }

    async listStatusPeticao() {
        const resp = await api.get('listStatusDenuncia')
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async listStatusAcompanhamento() {
        const resp = await api.get('listStatusAcompanhamento')
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async updateStatusDenuncia(alteracaoStatus: any) {
        const resp = await api.put('updateStatusDenuncia', alteracaoStatus)
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async createProcessoSEI(idFormularioPeticao: any) {
        const resp = await api.post('createProcessoSEI', {idFormularioPeticao})
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async filtroEstadoCidade(idStatus: any, estado: any, cidade: any) {
        const resp = await api.get('filtroEstadoCidade', { params: { idStatus, estado, cidade } })
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async listTodosStatusDenuncias() {
        const resp = await api.get('listTodosStatusDenuncias')
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async getStatusDenunciaById(idStatus1: any, idStatus2: any) {
        const resp = await api.get('getStatusDenunciaById', { params: { idStatus1, idStatus2 } })
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }
}

export default new FormularioPeticao();